__turbopack_context__.v({
  "active": "_53lSUW_active",
  "disabled": "_53lSUW_disabled",
  "freeForCart": "_53lSUW_freeForCart",
  "previewAdd": "_53lSUW_previewAdd",
  "previewRemove": "_53lSUW_previewRemove",
  "slot": "_53lSUW_slot",
});
